import DepsService from 'services/dependencies';

const CONTEXT = 'user';

export const fetchLinkedRetailers = async (queryParams) => {
  const { url } = DepsService.rest.account.linkedRetailers.get;

  return DepsService.restSrv.get(CONTEXT, url, queryParams);
};

export const updateLinkedRetailers = (data) => {
  const { url } = DepsService.rest.account.linkedRetailers.update;

  return DepsService.restSrv.create(CONTEXT, url, data);
};

export const deleteLinkedRetailers = (data) => {
  const { url } = DepsService.rest.account.linkedRetailers.update;

  return DepsService.restSrv.remove(CONTEXT, url, null, { data });
};



// WEBPACK FOOTER //
// ./src/modules/user/resources/linked-retailers.api.js